import React, { useState } from "react";
import styled from "styled-components";
import { Device } from "../../../helpers/screenSizes";
import { InternalLink } from "../../link/InternalLink";
import { MobileMenu } from "./children/MobileMenu";
import { NavigationProps } from "./types/navigation";

const Header = styled.header<{ isMenuOpen: boolean }>`
  z-index: 1;
  align-items: center;
  display: flex;
  font-size: 16px;
  height: 60px;
  justify-content: space-between;
  padding: 0 30px;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.header?.backgroundColor || theme.color.primary};
  font-family: ${({ theme }) => theme.header?.fontFamily};
  position: initial;
  line-height: normal;

  @media ${Device.mobile} {
    height: 60px;
    padding: 0 10px;
    ${({ isMenuOpen }) => isMenuOpen && `position: fixed; top: 0;`}
  }
`;

const NavLeft = styled.span`
  display: flex;
  align-items: center;

  > a {
    height: 50px;
  }
`;

const Logo = styled.img`
  height: 50px;
`;

const NavLink = styled.span<{ active?: boolean }>`
  color: white;
  opacity: ${({ theme }) => theme.header?.navLinkOpacity || "0.8"};
  cursor: pointer;
  text-transform: ${({ theme }) => theme.header?.textTransform};
  text-decoration: ${(props) => props.active && "underline"};
  font-family: ${({ theme }) => theme.header?.fontFamily};
  font-weight: ${({ theme }) => theme.header?.fontWeight};

  &:hover {
    opacity: 1;
  }
`;

const NavLinksWrapper = styled.span`
  a {
    padding: 0 15px;
  }
  a:first-child {
    padding-left: 30px;
  }

  @media ${Device.mobile} {
    display: none;
  }
`;

export const PortalHeader: React.FC<NavigationProps> = (props) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { fallbackUrl, logo, links, pathname, handleKeyDown, signOut } = props;

  const handleSignout = () => {
    setMenuOpen(false);
    signOut();
  };

  return (
    <Header isMenuOpen={isMenuOpen}>
      {/* Mobile menu 🍔 */}
      <MobileMenu
        {...props}
        isMenuOpen={isMenuOpen}
        setMenuOpen={setMenuOpen}
      />
      <NavLeft>
        {/* Logo */}
        <InternalLink href={fallbackUrl || ""}>
          <Logo alt={logo?.alt || "logo"} src={logo?.src || ""} />
        </InternalLink>
        {/* Links */}
        <NavLinksWrapper>
          {links?.map((link) => {
            const { position, title, url } = link;
            return (
              <InternalLink key={position} href={url}>
                <NavLink
                  active={url.includes(pathname)}
                  onKeyDown={handleKeyDown}
                  role="link"
                  tabIndex={0}
                >
                  {title}
                </NavLink>
              </InternalLink>
            );
          })}
        </NavLinksWrapper>
      </NavLeft>
      {/* Sign Out */}
      <NavLink
        onKeyDown={handleKeyDown}
        onClick={handleSignout}
        role="link"
        tabIndex={0}
      >
        Sign Out
      </NavLink>
    </Header>
  );
};
